<template>
	<div>
		<v-form v-model="valid" ref="form">
			<auto-complete-entity
				ref="account"
				v-model="value.accountId"
				entityApi="account"
				:itemPreSelected="selectedAccount"
				fieldApi="name"
				itemText="name"
				itemValue="id"
				:label="$t('entities.job.props.accountId')"
				prependIcon="mdi-find-replace"
			/>
			<auto-complete-entity
				ref="item"
				v-model="value.itemId"
				entityApi="item"
				:itemPreSelected="selectedItem"
				@change="itemChange"
				itemText="description"
				itemValue="id"
				:label="$t('entities.job.props.item')"
				prependIcon="mdi-find-replace"
			/>
			<v-select
				v-if="selectedItem"
				v-model="value.environmentId"
				:items="environments"
				item-text="description"
				item-value="id"
				:label="$t('entities.job.props.environmentId')"
				:rules="$isRequiredRule"
			></v-select>

			<v-text-field
				:label="$t('entities.job.props.description')"
				:rules="$isRequiredRule"
				v-model="value.description"
			></v-text-field>

			<v-text-field
				:readonly="value.id"
				:label="$t('entities.job.props.qt')"
				v-model="value.qt"
				type="number"
			></v-text-field>
			<v-checkbox
				:label="$t('entities.job.props.group')"
				v-model="value.group"
			></v-checkbox>
			<v-text-field
				v-if="value.group"
				:label="$t('entities.job.props.code')"
				v-model="value.code"
			></v-text-field>

			<entity-field-custom-autoform
				v-model="value"
				entity="Job"
			></entity-field-custom-autoform>
		</v-form>
	</div>
</template>

<script>
	import itemService from "@/services/itemService.js";
	import accountService from "@/services/accountService.js";
	import environmentService from "@/services/environmentService.js";
	import jobStageService from "@/services/jobStageService.js";

	export default {
		name: "solic-job-form",
		props: {
			value: {
				default() {
					return {
						code: "",
						versionId: "",
						environmentId: "",
						accountId: "",
						descriptions: "",
						qt: null,
					};
				},
			},
		},
		components: {},
		data() {
			return {
				tab: null,
				valid: true,
				selectedItem: {},
				selectedAccount: {},
				environments: [],
				alert: {
					alerts: [],
					type: "error",
				},
			};
		},
		watch: {
			async value() {
				this.$refs.form.resetValidation();
				this.selectedItem = "";
				this.selectedAccount = "";
				await this.getItems();
			},
			"value.itemId"() {
				//this.value.environmentId = null;
				// if (!this.value.description && this.selectedItem)
				//   this.value.description = this.selectedItem.description;
				// if (this.selectedItem)
				//   this.value.environmentId = this.selectedItem.environmentId;
			},
		},
		methods: {
			itemChange(item) {
				this.selectedItem = item;
				this.value.environmentId = item.environmentId;
				this.value.description = item.description;
				this.$forceUpdate();
			},
			isValid() {
				if (this.$refs.jobStagesFormRef != null) {
					let jobStagesIsValid = this.$refs.jobStagesFormRef.saveChanges();
					if (!jobStagesIsValid) return false;
				}
				return this.$refs.form.validate();
			},
			async selectItem(row) {
				this.value.itemId = row.id;
				this.selectedItem = row;
			},
			selectAccount(row) {
				this.selectedAccount = row;
				this.value.accountId = row.id;
			},
			async getItemById() {
				if (!this.value.itemId) return;
				let res = await itemService.getById(this.value.itemId);

				if (res.success) this.selectedItem = res.data;
				else this.alert.alerts = res.data;
			},
			async getAccountById() {
				if (!this.value.accountId) return;
				let res = await accountService.getById(this.value.accountId);
				if (res.success) this.selectedAccount = res.data;
				else this.alert.alerts = res.data;
			},
			async getEnvironments() {
				let res = await environmentService.getAll();
				if (res.success) {
					this.environments = res.data.data;
					if (this.selectedItem && this.selectedItem.environmentId) {
						let environment = this.environments.filter(
							(e) => e.id == this.selectedItem.environmentId
						)[0];
						this.value.environmentId = environment.id;
					}
				} else this.alert.alerts = res.data;
			},
			async getJobStages() {
				if (!this.value.id) return;
				this.value.jobStages = [];
				let res = await jobStageService.getAll(this.value.id);
				if (res.success) this.value.jobStages = res.data.data;
				else this.alert.alerts = res.data;
			},
			async getItems() {
				await this.getEnvironments();
				await this.getAccountById();
				await this.getItemById();
				await this.getJobStages();
			},
		},
		async mounted() {
			await this.getItems();
		},
	};
</script>
